import NewBaseTable from 'components/NewBaseTable/NewBaseTable';
import { TFunction } from 'i18next';
import { TableAction } from 'pages/UserManagementTwo';
import React from 'react';
import { PaginatedResults } from 'types';
import { Group, User, UserTypes } from 'types/user-management';
import { usersColumnConfigs } from '../utils';
import { Pagination } from 'components';
import { PageSelection, PaginationContainer } from '.';
import { RibbonItem } from 'components/RibbonComponent';

interface props {
  isLoading: boolean;
  dataWithKeys: (User | Group)[];
  handleTableAction: ({ flyoutType, flyoutItemId, selectedUser }: TableAction) => void;
  t: TFunction<'fpns'[], undefined>;
  handleClickRow?: (action?: string, data?: UserTypes) => void;
  selectedTableItems?: UserTypes[];
  defaultUserSortState: { id: string; desc: boolean };
  searchInputValue: (inputValue?: string, searchType?: string) => void;
  handleGroupSearch: (val?: string) => void;
  result: PaginatedResults<Group> | undefined;
  onPageChange: (page: number) => void;
  pageLength: number;
  pageNumberState: number;
  pageNumber: number;
  tableHeaderButtons?: RibbonItem[];
  resetControlCheck?: boolean;
  setResetControlCheck?: (val: boolean) => void;
  isGroupPage?: boolean;
  selectedPage?: PageSelection;
}
export const DisplayExistingUsers = ({
  isLoading,
  dataWithKeys,
  handleTableAction,
  t,
  handleClickRow,
  defaultUserSortState,
  searchInputValue,
  handleGroupSearch,
  result,
  onPageChange,
  pageLength,
  pageNumberState,
  pageNumber,
  tableHeaderButtons,
  isGroupPage,
  selectedPage
}: props): JSX.Element => {
  return (
    <>
      <NewBaseTable
        newTableData={isLoading ? [] : dataWithKeys}
        columnConfigs={usersColumnConfigs(handleTableAction, t, handleClickRow, selectedPage)}
        mobileViewRowHeader="name"
        textAlign="left"
        sortState={defaultUserSortState}
        enableFilter={!isGroupPage}
        isShowColumnOptions={true}
        // handleFilterRequest={updateTableOnFilterChange}
        isDataLoading={isLoading}
        isShowGlobalSearch={true}
        searchPlaceholder={t('mm_user_mgrm_table_search_user') as string}
        searchInputValue={searchInputValue}
        handleFilterRequest={handleGroupSearch}
        customClassName="userTable"
        tableHeaderButtons={tableHeaderButtons}
        shadow={true}
      />
      {result && (
        <PaginationContainer>
          <Pagination
            onPageChange={onPageChange}
            itemsPerPage={pageLength}
            numItems={result?.total}
            forcePage={pageNumberState}
            currentPage={pageNumber}
          />
        </PaginationContainer>
      )}
    </>
  );
};
